module.exports = __webpack_public_path__ + "static/bg_HeroCs_tab-430b28705b308a65ad953831f9f67ecf.jpg";